// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OelW","colMin":"styles_colMin__31wOp"};